var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("settings-property", {
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                _c("v-select", {
                  staticClass: "form-control",
                  attrs: {
                    options: _vm.audienceSelectionOptions,
                    disabled: !_vm.canWrite,
                    clearable: false,
                    "close-on-select": ""
                  },
                  model: {
                    value: _vm.audienceSelectionModel,
                    callback: function($$v) {
                      _vm.audienceSelectionModel = $$v
                    },
                    expression: "audienceSelectionModel"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "input",
            fn: function() {
              return [
                _vm.isNewAudience
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newAudienceNameModel,
                          expression: "newAudienceNameModel"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: !_vm.canWrite },
                      domProps: { value: _vm.newAudienceNameModel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.newAudienceNameModel = $event.target.value
                        }
                      }
                    })
                  : _c("v-select", {
                      staticClass: "form-control",
                      attrs: {
                        label: "name",
                        options: _vm.audiences,
                        disabled: !_vm.canWrite || !_vm.audiences.length,
                        clearable: "",
                        searchable: "",
                        filterable: "",
                        taggable: "",
                        "close-on-select": ""
                      },
                      model: {
                        value: _vm.existingAudienceModel,
                        callback: function($$v) {
                          _vm.existingAudienceModel = $$v
                        },
                        expression: "existingAudienceModel"
                      }
                    })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }